var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.visible,
        id: "admin-non-metrc-category-modal",
        title: _vm.isEdit
          ? "Edit Non-METRC Category"
          : "Add Non-METRC Category",
        "hide-footer": "",
        centered: "",
        size: "lg",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Name" } },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text", state: _vm.fieldValid("name") },
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "formData.name",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        { attrs: { state: _vm.fieldValid("name") } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formValidation.name) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Code" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "text",
                          disabled: _vm.isEdit,
                          state: _vm.fieldValid("code"),
                        },
                        model: {
                          value: _vm.formData.code,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "code",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "formData.code",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        { attrs: { state: _vm.fieldValid("code") } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formValidation.code) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Definition" } },
            [
              _c("b-form-textarea", {
                attrs: { rows: "3", state: _vm.fieldValid("definition") },
                model: {
                  value: _vm.formData.definition,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "definition",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.definition",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("definition") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.definition) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Sort Order" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "number",
                          min: "0",
                          state: _vm.fieldValid("sort_order"),
                        },
                        model: {
                          value: _vm.formData.sort_order,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "sort_order", $$v)
                          },
                          expression: "formData.sort_order",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        { attrs: { state: _vm.fieldValid("sort_order") } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formValidation.sort_order) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Browse Groups" } },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: _vm.browseGroupOptions,
                          "select-size": Math.min(
                            Math.max(_vm.browseGroupOptions.length, 4),
                            8
                          ),
                          state: _vm.fieldValid("browse_group_ids"),
                          multiple: "",
                        },
                        model: {
                          value: _vm.formData.browse_group_ids,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "browse_group_ids", $$v)
                          },
                          expression: "formData.browse_group_ids",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        {
                          attrs: { state: _vm.fieldValid("browse_group_ids") },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formValidation.browse_group_ids) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Facet Values" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.facetValueOptions,
                  "select-size": 10,
                  state: _vm.fieldValid("facet_value_ids"),
                  multiple: "",
                },
                model: {
                  value: _vm.formData.facet_value_ids,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "facet_value_ids", $$v)
                  },
                  expression: "formData.facet_value_ids",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("facet_value_ids") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.facet_value_ids) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Admin Notes" } },
            [
              _c("b-form-textarea", {
                attrs: { rows: "3", state: _vm.fieldValid("admin_notes") },
                model: {
                  value: _vm.formData.admin_notes,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "admin_notes",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.admin_notes",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("admin_notes") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.admin_notes) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Submit\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }